import actions from './actions';
import axios, { CancelToken } from '../axios';
import store from '../store';
import { message } from 'antd';
import errorHandling from '../error';
import Cookies from 'js-cookie';

const {
  getBlogBegin, getBlogSuccess, getBlogFailed,
  addBlogBegin, addBlogSuccess, addBlogFailed,
  updateBlogBegin, updateBlogSuccess, updateBlogFailed,
  deleteBlogBegin, deleteBlogSuccess, deleteBlogFailed,
} = actions;

// GETTING ALL BLOGS
let cancelToken;
export const getAllBlogs = (filter) => async (dispatch) => {
  if (cancelToken) cancelToken.cancel();
  cancelToken = CancelToken.source();
  try {
    dispatch(getBlogSuccess({ totalBlogs: 0, blogs: [] }));
    dispatch(getBlogBegin());
    const res = await axios.get(`blogs${filter ? filter : ''}`, { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` }, cancelToken: cancelToken?.token });
    dispatch(getBlogSuccess(res.data));
  } catch (err) {
    dispatch(getBlogFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err, false))
  }
}

// GETTING SINGLE BLOG
export const getSingleBlog = id => async (dispatch) => {
  try {
    dispatch(getBlogBegin());
    const res = await axios.get(`blogs/${id}`, { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` } });
    dispatch(getBlogSuccess({ blogs: [res.data.blog], total: 1 }));
  } catch (err) {
    dispatch(getBlogFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err))
  }
}

// ADDING NEW BLOG
export const addNewBlog = (data, form, history) => async (dispatch) => {
  try {
    const state = store.getState();
    dispatch(addBlogBegin());
    const res = await axios.post('blogs', data, { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` } });

    dispatch(addBlogSuccess([res.data.blog, ...state.blog.blogs]));
    message.success('New blog created successfully');
    history.push(`/${state.auth.user.role.name}/blogs`);
    form.resetFields();
  } catch (err) {
    dispatch(addBlogFailed(err?.message));
    dispatch(errorHandling(err))
  }
}

// UPDATING BLOG
export const editBlog = (id, datas, history) => async (dispatch) => {
  try {
    const state = store.getState();
    dispatch(updateBlogBegin());
    const res = await axios.put(`blogs/${id}`, datas, { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` } });
    const newBlogs = state.blog.blogs.map(blog => {
      if (blog._id === id) return res.data.blog;
      else return blog;
    })
    dispatch(updateBlogSuccess(newBlogs));
    message.success('Blog updated successfully');
    history.push(`/${state.auth.user.role.name}/blogs`);
  } catch (err) {
    dispatch(updateBlogFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err))
  }
}

// DELETE BLOG
export const deleteBlog = id => async (dispatch) => {
  try {
    const state = store.getState();
    dispatch(deleteBlogBegin());
    await axios.delete(`blogs/${id}`, { headers: { 'Authorization': `Bearer ${Cookies.get('authToken')}` } });

    dispatch(deleteBlogSuccess(state.blog.blogs.filter(blog => blog._id !== id)));
    message.success('Blog deleted successfully')
  } catch (err) {
    dispatch(deleteBlogFailed(err?.response?.data?.msg));
    dispatch(errorHandling(err))
  }
} 